import { Component, OnInit, Inject, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { Absence } from 'src/app/_model/Absence';
import { AbsenceService } from 'src/app/_services/absence.service';
import { ToastrService } from 'ngx-toastr';
import { WfApproveRequest } from 'src/app/_model/request/WfApproveRequest';
import { User } from 'src/app/_model/user';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-rejectselected',
  templateUrl: './rejectselected.component.html',
  styleUrls: ['./rejectselected.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class RejectselectedComponent implements OnInit {
  request:WfApproveRequest=new WfApproveRequest();
  currentUser: User;
  constructor(public dialogRef: MatDialogRef<RejectselectedComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: Absence[],
    private authService: AuthenticationService,
    private absenceService: AbsenceService,
    private toastr: ToastrService) {
      this.currentUser = this.authService.currentUserValue;
     }

  ngOnInit() {
  }
  rejectSelected(){

    this.data.forEach(element => {
      this.request.employeeId = this.currentUser.employeeId;
      this.request.operationRecordId=element.id;
      this.request.operationTableName="ABSENCE";
      this.absenceService.rejectAbsence(this.request).subscribe(result => {
        this.toastr.success('Reddetme işlemi başarılı', '');
        this.dialogRef.close();
      }, error => {
        this.toastr.error(error.error.msg, 'Hata');
        this.dialogRef.close();
      });
    });

  }
}
